import React, { useState } from 'react';
import styled from 'styled-components';
import MobileAppDrawer from './MobileAppDrawer';
import { useWindows } from '../../contexts/WindowContext';
import TerminalApp from '../Applications/Terminal/TerminalApp';

const DockContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background: rgba(0, 0, 0, 0.95);
  border-top: 2px solid rgba(0, 255, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: space-around;
  z-index: 1500;
  backdrop-filter: blur(15px);
`;

const DockButton = styled.button`
  background: rgba(0, 255, 0, 0.2);
  border: 2px solid rgba(0, 255, 0, 0.5);
  border-radius: 15px;
  width: 60px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #00ff00;
  font-size: 20px;

  &:active {
    background: rgba(0, 255, 0, 0.3);
    transform: scale(0.95);
  }
`;

const ButtonLabel = styled.span`
  font-size: 8px;
  margin-top: 2px;
`;

const MobileDock: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { openWindow } = useWindows();

  const handleTerminalOpen = () => {
    openWindow({
      title: 'Terminal Emulator',
      component: TerminalApp,
      isMinimized: false,
      isMaximized: false,
      position: { x: 0, y: 0 },
      size: { width: window.innerWidth, height: window.innerHeight }
    });
  };

  return (
    <>
      <DockContainer>
        <DockButton onClick={() => setIsDrawerOpen(true)}>
          📱
          <ButtonLabel>Apps</ButtonLabel>
        </DockButton>
        <DockButton onClick={() => window.location.reload()}>
          🏠
          <ButtonLabel>Home</ButtonLabel>
        </DockButton>
        <DockButton onClick={handleTerminalOpen}>
          💻
          <ButtonLabel>Terminal</ButtonLabel>
        </DockButton>
      </DockContainer>
      
      <MobileAppDrawer 
        isOpen={isDrawerOpen} 
        onClose={() => setIsDrawerOpen(false)} 
      />
    </>
  );
};

export default MobileDock;
